import React from 'react';
import { Tag } from 'antd';
import { InvoiceStatusV2 } from '@/store/invoice/useGetInvoicesV2';
import { STATUS_CONFIG } from '../const';

type Props = {
    status: InvoiceStatusV2;
};

export function StatusTag({ status }: Props) {
    const config = STATUS_CONFIG[status];

    if (!config) return <Tag>{status}</Tag>;

    return <Tag color={config.tagColor}>{config.label}</Tag>;
}
